module.exports = __webpack_public_path__ + "static/media/sogno.d2c5c4aa.mp4";